import React from "react";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";

const parseNames = (value) =>
  String(value || "")
    .split(/\r?\n|,|;/)
    .map((name) => name.trim())
    .filter(Boolean);

export const serializeCountGroupRoles = (groups = []) =>
  groups.map((group) => ({
    digitators: parseNames(group.digitatorsText ?? (group.digitators || []).join("\n")),
    counters: parseNames(group.countersText ?? (group.counters || []).join("\n")),
  }));

function CountGroupSetup({ groupCount, groups, onGroupCountChange, onGenerate, onGroupsChange }) {
  const updateRoleNames = (index, field, value) => {
    const next = groups.map((group, groupIndex) =>
      groupIndex === index ? { ...group, [field]: value } : group
    );
    onGroupsChange(next);
  };

  return (
    <Stack spacing={1.2}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "flex-end" }}>
        <TextField
          size="small"
          type="number"
          label="Numero de grupos"
          value={groupCount}
          onChange={(event) => onGroupCountChange(event.target.value)}
          inputProps={{ min: 1, max: 20, step: 1 }}
          sx={{ width: { xs: "100%", sm: 190 } }}
        />
        <Button variant="outlined" onClick={onGenerate}>
          Generar grupos
        </Button>
      </Stack>

      {groups.map((group, index) => (
        <Box key={`count-group-${index + 1}`} sx={{ border: 1, borderColor: "divider", p: 1.2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1 }}>
            Grupo {index + 1}
          </Typography>
          <Stack direction={{ xs: "column", md: "row" }} spacing={1}>
            <TextField
              size="small"
              fullWidth
              multiline
              minRows={2}
              label="Digitadores"
              value={group.digitatorsText ?? (group.digitators || []).join("\n")}
              onChange={(event) => updateRoleNames(index, "digitatorsText", event.target.value)}
              placeholder="Juan"
            />
            <TextField
              size="small"
              fullWidth
              multiline
              minRows={2}
              label="Contadores"
              value={group.countersText ?? (group.counters || []).join("\n")}
              onChange={(event) => updateRoleNames(index, "countersText", event.target.value)}
              placeholder="Pedro\nLuis"
            />
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}

export default CountGroupSetup;
